import Context, {} from './context.js';
import ApiService from './services/api.js';
import CallsService from './services/calls.js';
import KwentaTokenService from './services/kwentaToken.js';
import PointsService from './services/points.js';
import PricesService from './services/prices.js';
import ReferralsService from './services/referrals.js';
import SnxPerpsV2Service from './services/snxPerpsV2.js';
import SnxPerpsV3Service from './services/snxPerpsV3.js';
import StatsService from './services/stats.js';
import SystemService from './services/system.js';
import TokensService from './services/tokens.js';
import TransactionsService from './services/transactions.js';
class KwentaSDK {
    context;
    api;
    snxPerpsV2;
    snxPerpsV3;
    transactions;
    kwentaToken;
    prices;
    stats;
    referrals;
    system;
    calls;
    tokens;
    points;
    constructor(context) {
        this.context = new Context(context);
        this.api = new ApiService(this);
        this.snxPerpsV2 = new SnxPerpsV2Service(this);
        this.prices = new PricesService(this);
        this.tokens = new TokensService(this);
        this.transactions = new TransactionsService(this);
        this.kwentaToken = new KwentaTokenService(this);
        this.stats = new StatsService(this);
        this.snxPerpsV3 = new SnxPerpsV3Service(this);
        this.calls = new CallsService(this);
        this.referrals = new ReferralsService(this);
        this.system = new SystemService(this);
        this.points = new PointsService(this);
    }
    setWalletClient(signer) {
        return this.context.setWalletClient(signer);
    }
    setWalletAddress(walletAddress) {
        return this.context.setWalletAddress(walletAddress);
    }
}
export { Context, KwentaSDK };
export default KwentaSDK;
//# sourceMappingURL=index.js.map